export enum AnalyticsConfigTypeEnum {
  Mixpanel = 1,
  MetaPixel = 2,
  GoogleAnalytics = 3,
  GoogleTagManager = 4,
}

export const MIXPANEL_PROJECT_ID = "MixpanelProjectId";
export const PIXEL_PROJECT_ID = "PixelProjectId";

